import { makeStyles, Theme } from "@material-ui/core/styles";

const styles = makeStyles((theme: Theme) => ({
  dialog: {},
  inputField: {
    height: 40,
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing(1),
  },
  selectCategory: {
    height: 40,
  },
  selectLabel: {
    marginBottom: 10,
  },
  switchSection: {
    verticalAlign: 'middle',
  },
  formControl: {
    minWidth: 120,
    height: 40,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  translationsContainer: {
    height: 300,
    width: '100%',
    overflowY: 'auto',
    border: '1px solid #cccccc',
  },
  containerAppBar: {
    height: 40,
    width: '100%',
    backgroundColor: theme.palette.appBarsColor.main,
    verticalAlign: 'middle',
    position: 'relative',
  },
  containerTitle: {
    color: 'white',
    fontSize: 20,
    marginLeft: 10,
    paddingTop: 5,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  translationItem: {
    paddingLeft: 40,
    color: 'grey',
    textTransform: 'none',
  },
  containerTitleButton: {
    position: 'absolute',
    right: 0,
    top: -5,
    color: 'white',
  },
  info: {
    color: 'grey',
    textTransform: 'none',
  },
  title: {
    fontSize: 23,
    fontWeight: 'bold',
    textTransform: 'none',
  },
  subtitle: {
    fontSize: 17,
    fontWeight: 'bold',
    marginTop: 13,
    marginBottom: 10,
  },
  holdingProfilesContainer: {
    width: '100%',
    border: '1px solid #cccccc',
    height: 150,
    marginTop: 20,
  },
  cicularProgress: {},
  chipInput: {},
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  tab: {
    textTransform: 'none',
    height: 35,
    fontSize: 12,
  },
  tabSelected: {
    textTransform: 'none',
    height: 35,
    fontSize: 12,
    backgroundColor: '#ededed',
  },
  separation: {
    marginTop: 10,
    marginBottom: 10,
  },
  holdingProfilesTabs: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
  },
  addToCatalog:{
    minWidth: '350px', maxWidth: '350px', maxHeight:'40px',
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "white"
    },
  },
  addToCatalogAutocomplete:{
    minWidth: '350px', maxWidth: '380px', maxHeight:'40px', overflow: 'auto', backgroundColor:'white'
  },
  dialogActionsWrapper: {
    display: 'flex',
    paddingRight: '24px',
    paddingLeft: '24px',
  },
  activeBtnWrapper: {},
  dialogBtn: {
    marginLeft: '8px'
  }
}));

export default styles;
